<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Store Products</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">{{ this.store.name }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addPriceModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Update/Add Product Price
                </button>
            </div>

        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.store.name }} Products</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allProducts"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="props.row.image" target="_blank">
                                   <img :src="props.row.image" :alt="props.row.name +' Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <span v-else-if="props.column.field === 'is_new'">
                                <template v-if="props.row.is_new">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'is_active'">
                                <template
                                    v-if="!props.row.is_active || props.row.sizes.every(size => size.pivot.status == false)">
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'sizes'">
                                <template v-for="size in props.row.sizes">
                                    <span
                                        class="">{{ size.name }}
                                        <span v-if="size.pivot.discount_price!==null">
                                            (&#8358;{{
                                                size.pivot.discount_price
                                            }})
                                        </span>
                                        <span v-else>
                                            (&#8358;{{
                                                size.pivot.price
                                            }})
                                        </span>
                                    </span>
                                    <br>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#" class="dropdown-item" @click.prevent="editSizes(props.row.id)">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete all
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>

                <div class="modal fade add-price-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
                     aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <form @submit.prevent="addPrice">
                                <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                                    {{ isEditing ? "Edit" : "Add/Update" }} Product Price</h4>
                                    <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                        aria-hidden="true">×</span></button>
                                </div>
                                <div class="modal-body">
                                    <template v-for="(n,index) in formCount">
                                        <div class="row">
                                            <div class="form-group col-6">
                                                <div class="controls">
                                                    <label class="form-label">Associated Product</label>
                                                    <template v-if="isEditing">
                                                    <span class="float-right">
                                                        <a href="#"
                                                           @click="showPriceDeletionAlert(price[index].product_id,price[index].size_id)"
                                                           class="text-danger">
                                                            <i class="feather icon-trash-2"></i>Delete
                                                        </a>
                                                    </span>
                                                    </template>

                                                    <select v-model="price[index].product_id" id="" class="form-control"
                                                            required>
                                                        <option value="" selected>Select the Product
                                                        </option>
                                                        <option v-for="product in availableProducts" :key="product.id"
                                                                :value="product.id">
                                                            {{ product.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group col-6">
                                                <div class="controls">
                                                    <label class="form-label">Product Size</label>
                                                    <select v-model="price[index].size_id" id="" class="form-control"
                                                            required>
                                                        <option value="" selected>Select a Product Size for the price
                                                        </option>
                                                        <option v-for="size in sizes" :key="size.id"
                                                                :value="size.id">
                                                            {{ size.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="form-group col-4">
                                                <label>Product Price</label>
                                                <input v-model="price[index].price" type="number" required="required"
                                                       class="form-control">
                                                <!--                                                <div v-if="typeof price.errors[index].price != 'undefined'" class="text-danger text-small">-->
                                                <!--                                                    {{ price[index].errors.price }}-->
                                                <!--                                                </div>-->
                                            </div>

                                            <div class="form-group col-4">
                                                <label>Product Discount Price</label>
                                                <input v-model="price[index].discount_price" type="number"
                                                       class="form-control">
                                                <small class="text-danger">Please leave this empty if you do not want a
                                                    discount price for this product</small>
                                            </div>

                                            <div class="form-group col-4">
                                                <div class="controls">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                               :id="'defaultCheck'+ index"
                                                               v-model="price[index].status" :true-value="true"
                                                               :false-value="false">
                                                        <label class="form-check-label" for="defaultCheck2">
                                                            Is this Size Available?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="!isEditing">
                                        <span>
                                            <a href="#" @click="addToFormCount">Add +</a>
                                        </span>

                                        <span v-if="formCount>1">
                                            <a href="#" @click="subtractFromFormCount" class="text-danger">- Remove</a>
                                        </span>
                                    </template>
                                </div>

                                <div class="modal-footer">
                                    <button class="btn btn-primary" :disabled="saving">
                                        Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Store Details'},
    props: ['store', 'products', 'sizes', 'availableProducts'],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            formCount: 1,
            isEditing: false,
            price: [
                {
                    discount_price: null,
                    price: null,
                    product_id: "",
                    size_id: "",
                    status: true,
                }
            ],
            filter: {},
            isLoadingFilter: false,
            allProducts: [],
            baseUrl: '',
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Product Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Category', field: 'category_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Image', field: 'image', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Description', field: 'description', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Sizes', field: 'sizes', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Available', field: 'is_active', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
            saving: false,

        }
    },

    mounted() {

        this.baseUrl = window.location.origin;
        this.allProducts = this.products.data;
        this.totalRecords = this.products.total
    },

    methods: {

        addToFormCount() {
            this.formCount += 1;
            this.price.push({
                discount_price: null,
                price: null,
                product_id: "",
                size_id: "",
                status: true,
            })
        },
        subtractFromFormCount() {
            if (this.formCount > 1) {
                this.formCount -= 1;
                this.price.pop();
            } else {
                this.formCount = 1;
            }
        },
        addPriceModal() {
            this.isEditing = false;
            this.price = [{
                discount_price: null,
                price: null,
                product_id: "",
                size_id: "",
                status: true,
            }];
            $('.add-price-modal').modal('show');
            this.price.price = ""
            this.price.discount_price = ""
            this.price.product_id = ""
            this.price.size_id = "";
            this.price.status = true;
        },

        async editSizes(resourceId) {
            try {

                const product = this.allProducts.find(object => object.id === resourceId);
                this.price = [];
                this.formCount = 0;
                product.sizes.map((size) => {
                    this.formCount++;
                    this.price.push({
                        price: size.pivot.price,
                        discount_price: size.pivot.discount_price,
                        product_id: size.pivot.product_id,
                        size_id: size.id,
                        status: size.pivot.status,
                    });
                });

                this.isEditing = true;
                $('.add-price-modal').modal('show');

            } catch (e) {
                console.log(e);
                this.price = {
                    price: null,
                    discount_price: null,
                    product_id: "",
                    size_id: "",
                    status: true
                };
            }
        },
        async addPrice() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    this.formCount = 1;
                    this.price = [{
                        price: null,
                        discount_price: null,
                        product_id: "",
                        size_id: "",
                        status: true
                    }];
                },
                onError: () => {
                    this.saving = false;
                }
            };

            await this.$inertia.post(route('admin.stores.product.store', this.store.id), {price: [...this.price]}, options);
            this.saving = false;
            $('.add-price-modal').modal('hide');
            await this.paginatedData();
        },

        async paginatedData() {
            try {
                let routeName = 'admin.stores.details';

                let response = await axios.get(route(routeName, this.store.id), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allProducts = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async deleteProduct(id) {
            await this.$inertia.delete(route('admin.stores.product.delete', [this.store.id, id,]), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },
        async showAlert(productId) {
            const details = {
                title: "Are you sure you want to delete all product from this store?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteProduct(productId) : "";
        },

        async deletePrice(productId, sizeId) {
            await this.$inertia.delete(route('admin.stores.product.price.delete', [this.store.id, productId, sizeId,]), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },
        async showPriceDeletionAlert(productId, sizeId) {
            const details = {
                title: "Are you sure you want to delete this product price from this store?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deletePrice(productId, sizeId) : "";
            $('.add-price-modal').modal('hide');

        },
    }
}
</script>
